const useRemovePlaceholder = (selector: string) => {
  const el = document.querySelector(`${selector}`);

  if (el !== null) el.classList.remove('placeholder--wrapper');
  return;
};

export default useRemovePlaceholder;
